"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 30 24",
    width: props.size || props.width || "24px",
    id: "diners_club",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.575 23.775C24.071 23.806 30 18.475 30 11.991 30 4.899 24.07-.002 17.575 0h-5.59C5.41-.002 0 4.9 0 11.99c0 6.487 5.41 11.816 11.985 11.785h5.59z",
    fill: "#0079BE"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.973.951C5.981.953 1.125 5.828 1.123 11.845c.002 6.016 4.858 10.89 10.85 10.893 5.994-.002 10.85-4.877 10.851-10.893 0-6.017-4.857-10.892-10.85-10.894zM5.096 11.845a6.915 6.915 0 014.415-6.444v12.886a6.912 6.912 0 01-4.415-6.442zm9.338 6.445V5.4a6.911 6.911 0 010 12.89z",
    fill: "#FFF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.575 23.775C24.071 23.806 30 18.475 30 11.991 30 4.899 24.07-.002 17.575 0h-5.59C5.41-.002 0 4.9 0 11.99c0 6.487 5.41 11.816 11.985 11.785h5.59z",
    fill: "#0079BE"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.973.951C5.981.953 1.125 5.828 1.123 11.845c.002 6.016 4.858 10.89 10.85 10.893 5.994-.002 10.85-4.877 10.851-10.893 0-6.017-4.857-10.892-10.85-10.894zM5.096 11.845a6.915 6.915 0 014.415-6.444v12.886a6.912 6.912 0 01-4.415-6.442zm9.338 6.445V5.4a6.911 6.911 0 010 12.89z",
    fill: "#FFF"
  })));
};
var _default = exports["default"] = SvgComponent;